import {
  AbsatzPlan,
  AbsatzVorgabe,
  Currency,
  UmsatzPlan,
} from '@/domain/controlling/entities';
import { TableRow } from './types';
import { Planwert } from '@/domain/controlling/entities/planwert';
import { format } from 'date-fns';
import { de } from 'date-fns/locale/de';

export function mapPlanwerteToTableRow({
  planwerte,
  absatzVorgabe,
}: {
  planwerte: Planwert[];
  absatzVorgabe: AbsatzVorgabe;
}): TableRow[] {
  const tableRows = [];

  for (const currentPlanwert of planwerte) {
    const umsatz: Partial<TableRow> = mapUmsatz(currentPlanwert.umsatzPlan);
    const absatz: Partial<TableRow> = mapAbsatz(
      currentPlanwert.absatzPlan,
      absatzVorgabe,
    );

    const newPlanwert: TableRow = {
      date: {
        date: format(new Date(currentPlanwert.datum), 'yyyy-MM-dd', {
          locale: de,
        }),
        weekday: format(new Date(currentPlanwert.datum), 'EE', { locale: de }),
      },
      interneNotiz: currentPlanwert ? currentPlanwert.interneNotiz : '',
      ...umsatz,
      ...absatz,
    };
    tableRows.push(newPlanwert);
  }

  return tableRows;
}

function mapUmsatz(umsatzByCurrentDay: UmsatzPlan): Partial<TableRow> {
  return umsatzByCurrentDay
    ? {
        umsatzWert: umsatzByCurrentDay.umsatz.wert
          ? {
              amount: umsatzByCurrentDay.umsatz.wert.amount,
              currency: Currency[umsatzByCurrentDay.umsatz.wert.currency],
            }
          : undefined,
        umsatzZielproduktivitaet: umsatzByCurrentDay.umsatz.produktivitaet
          ? {
              amount: umsatzByCurrentDay.umsatz.produktivitaet.amount,
              currency:
                Currency[umsatzByCurrentDay.umsatz.produktivitaet.currency],
            }
          : undefined,
        umsatzZielstunden: umsatzByCurrentDay.umsatz.stunden,
        umsatzPrognose: umsatzByCurrentDay.prognose
          ? {
              amount: umsatzByCurrentDay.prognose.amount,
              currency: Currency[umsatzByCurrentDay.prognose.currency],
            }
          : undefined,
      }
    : {};
}

function mapAbsatz(
  absatzByCurrentDay: AbsatzPlan,
  absatzVorgabe: AbsatzVorgabe,
): Partial<TableRow> {
  return absatzByCurrentDay
    ? {
        absatzWert: absatzByCurrentDay.absatz.wert,
        absatzZielproduktivitaet:
          absatzByCurrentDay.absatz.produktivitaet.mpt &&
          absatzByCurrentDay.absatz.produktivitaet.stueck
            ? absatzVorgabe === AbsatzVorgabe.Stueck
              ? absatzByCurrentDay.absatz.produktivitaet.stueck
              : absatzByCurrentDay.absatz.produktivitaet.mpt
            : undefined,
        absatzZielstunden: absatzByCurrentDay.absatz.stunden,
        absatzPrognose: absatzByCurrentDay.prognose ?? undefined,
      }
    : {};
}
